import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Abrir Registro", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Responder", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_8 = { class: "ant-col ant-col-xs-5 ant-col-xl-5" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "ant-col ant-col-xs-9 ant-col-xl-9" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_15 = { class: "ant-col ant-col-xs-5 ant-col-xl-5" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_18 = { class: "ant-col ant-col-xs-5 ant-col-xl-5" }
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "ant-col ant-col-xs-10 ant-col-xl-10" }
const _hoisted_21 = ["value"]
const _hoisted_22 = {
  key: 1,
  class: "ant-col ant-col-xs-15 ant-col-xl-15"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  class: "ant-input",
  value: "Requisição expirada",
  disabled: true
}, null, -1)
const _hoisted_24 = {
  key: 2,
  class: "ant-col ant-col-xs-15 ant-col-xl-15"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  class: "ant-input",
  value: "Sem resposta",
  disabled: true
}, null, -1)
const _hoisted_26 = {
  key: 1,
  class: "ant-row"
}
const _hoisted_27 = { class: "ant-col ant-col-xs-5 ant-col-xl-5" }
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_30 = ["value"]
const _hoisted_31 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_32 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_status_requisicao_autorizacao = _resolveComponent("selecionar-status-requisicao-autorizacao")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_card = _resolveComponent("card")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_conta_pagar_modal = _resolveComponent("conta-pagar-modal")!
  const _component_requisicao_autorizacao_resposta_modal = _resolveComponent("requisicao-autorizacao-resposta-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: 800,
    centered: ""
  }, {
    title: _withCtx(() => [
      _createTextVNode("Requisição de Autorização")
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        (_ctx.UtilitarioGeral.validaCodigo(_ctx.props.requisicao.codigoRegistroRelacionado))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "ant-btn ant-btn-lg ant-btn-secondary",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.abrirRegistroRelacionado && _ctx.abrirRegistroRelacionado(...args)))
            }, _hoisted_2))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.abrirResposta && _ctx.abrirResposta(...args))),
          disabled: _ctx.props.requisicao.status !== _ctx.EStatusRequisicaoAutorizacao.Pendente
        }, _hoisted_5, 8, _hoisted_3)
      ])
    ]),
    default: _withCtx(() => [
      ((_ctx.modalBase.computedVisivel))
        ? (_openBlock(), _createBlock(_component_a_skeleton, {
            key: 0,
            loading: _ctx.telaBase.carregando,
            paragraph: { rows: 15 }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form, { layout: "vertical" }, {
                default: _withCtx(() => [
                  _createVNode(_component_card, { titulo: "SOLICITAÇÃO" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_a_form_item, {
                            label: "Status",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_status_requisicao_autorizacao, {
                                valor: _ctx.props.requisicao.status,
                                disabled: true
                              }, null, 8, ["valor"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_a_form_item, {
                            label: "Data da Solicitação",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("input", {
                                type: "text",
                                class: "ant-input",
                                value: _ctx.UtilitarioData.aplicaFormatoDataHoraMinutoSegundo(_ctx.props.requisicao.dataRequisicao),
                                disabled: ""
                              }, null, 8, _hoisted_9)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_a_form_item, {
                            label: "Quem Solicitou",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("input", {
                                type: "text",
                                class: "ant-input",
                                value: _ctx.props.requisicao.nomeUsuarioRequerente,
                                disabled: ""
                              }, null, 8, _hoisted_11)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_a_form_item, {
                            label: "Permissão",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("input", {
                                type: "text",
                                class: "ant-input",
                                value: _ctx.props.requisicao.descricaoPermissao,
                                disabled: ""
                              }, null, 8, _hoisted_13)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_a_form_item, {
                            label: "Detalhes da Solicitação",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_textarea, {
                                value: _ctx.props.requisicao.motivoRequisicao,
                                rows: 4,
                                disabled: ""
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  (_ctx.state.destinatarios.length > 0)
                    ? (_openBlock(), _createBlock(_component_card, {
                        key: 0,
                        titulo: "DESTINATÁRIOS DA REQUISIÇÃO"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.destinatarios, (destinatario, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "ant-row"
                            }, [
                              _createElementVNode("div", _hoisted_15, [
                                _createVNode(_component_a_form_item, {
                                  label: "Usuário",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("input", {
                                      type: "text",
                                      class: "ant-input",
                                      value: destinatario.nomeUsuario,
                                      disabled: true
                                    }, null, 8, _hoisted_16)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _createElementVNode("div", _hoisted_17, [
                                _createVNode(_component_a_form_item, {
                                  label: "Status",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_selecionar_status_requisicao_autorizacao, {
                                      valor: destinatario.status,
                                      disabled: true
                                    }, null, 8, ["valor"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              (destinatario.status === _ctx.EStatusRequisicaoAutorizacao.Autorizada || destinatario.status === _ctx.EStatusRequisicaoAutorizacao.Negada)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("div", _hoisted_18, [
                                      _createVNode(_component_a_form_item, {
                                        label: "Data da Resposta",
                                        class: "ss-margin-campos"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("input", {
                                            type: "text",
                                            class: "ant-input",
                                            value: _ctx.UtilitarioData.aplicaFormatoDataHoraMinutoSegundo(destinatario.dataResposta),
                                            disabled: true
                                          }, null, 8, _hoisted_19)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _createElementVNode("div", _hoisted_20, [
                                      _createVNode(_component_a_form_item, {
                                        label: "Resposta",
                                        class: "ss-margin-campos"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("input", {
                                            type: "text",
                                            class: "ant-input",
                                            value: destinatario.resposta,
                                            disabled: true
                                          }, null, 8, _hoisted_21)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ])
                                  ], 64))
                                : (destinatario.status === _ctx.EStatusRequisicaoAutorizacao.Expirada)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                      _createVNode(_component_a_form_item, {
                                        label: "Resposta",
                                        class: "ss-margin-campos"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_23
                                        ]),
                                        _: 1
                                      })
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                      _createVNode(_component_a_form_item, {
                                        label: "Resposta",
                                        class: "ss-margin-campos"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_25
                                        ]),
                                        _: 1
                                      })
                                    ]))
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.state.destinatarios.length === 0)
                    ? (_openBlock(), _createBlock(_component_card, {
                        key: 1,
                        titulo: "RESPOSTA"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.props.requisicao.status === _ctx.EStatusRequisicaoAutorizacao.Pendente || _ctx.props.requisicao.status === _ctx.EStatusRequisicaoAutorizacao.Expirada)
                            ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                                key: 0,
                                mensagem: "Requisição não foi respondida"
                              }))
                            : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                _createElementVNode("div", _hoisted_27, [
                                  _createVNode(_component_a_form_item, {
                                    label: "Data da Resposta",
                                    class: "ss-margin-campos"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("input", {
                                        type: "text",
                                        class: "ant-input",
                                        value: _ctx.UtilitarioData.aplicaFormatoDataHoraMinutoSegundo(_ctx.props.requisicao.dataResposta),
                                        disabled: ""
                                      }, null, 8, _hoisted_28)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_29, [
                                  _createVNode(_component_a_form_item, {
                                    label: "Quem Respondeu",
                                    class: "ss-margin-campos"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("input", {
                                        type: "text",
                                        class: "ant-input",
                                        value: _ctx.props.requisicao.nomeUsuarioAutorizante,
                                        disabled: ""
                                      }, null, 8, _hoisted_30)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_31, [
                                  _createVNode(_component_a_form_item, {
                                    label: "Detalhes da Resposta",
                                    class: "ss-margin-campos"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("input", {
                                        type: "text",
                                        class: "ant-input",
                                        value: _ctx.props.requisicao.resposta,
                                        disabled: ""
                                      }, null, 8, _hoisted_32)
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["loading"]))
        : _createCommentVNode("", true),
      (_ctx.props.requisicao.identificadorPermissao === 'AUT_ALCADA_DESPESAS')
        ? (_openBlock(), _createBlock(_component_conta_pagar_modal, {
            key: 1,
            editavel: false,
            operacao: _ctx.state.operacaoLancamento,
            visivel: _ctx.state.exibirLancamento,
            "onUpdate:visivel": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.exibirLancamento) = $event))
          }, null, 8, ["operacao", "visivel"]))
        : _createCommentVNode("", true),
      _createVNode(_component_requisicao_autorizacao_resposta_modal, {
        visivel: _ctx.state.exibirResposta,
        "onUpdate:visivel": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.exibirResposta) = $event)),
        codigos: [_ctx.props.requisicao.codigo],
        onConfirmacao: _ctx.confirmarResposta
      }, null, 8, ["visivel", "codigos", "onConfirmacao"])
    ]),
    _: 1
  }, 8, ["visible"]))
}